import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-598052da"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "module top_spacing-120 bottom_spacing-25" };
const _hoisted_2 = { class: "splide__track" };
const _hoisted_3 = { class: "splide__list" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
    key: 0,
    class: "footer-text"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("p", null, [
    /*#__PURE__*/ _createElementVNode("a", {
        class: "no-style",
        href: "/articles"
    }, "Read More")
], -1));
const _hoisted_7 = [
    _hoisted_6
];
const _hoisted_8 = { class: "backWrapper" };
const _hoisted_9 = {
    key: 0,
    href: "/articles",
    class: "backBtn"
};
import Splide from '@splidejs/splide';
import { HoverCursor } from 'hover-cursor';
import { ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'articles_listing_carousel',
    props: ['d'],
    setup(__props) {
        const props = __props;
        _useCssVars(_ctx => ({
            "352c3b07": (__props.d.background_colour)
        }));
        const splider = ref(null);
        // 991px is Boostrap breakpoint
        const shouldShowMobileDesign = ref(window.innerWidth <= 991);
        const updateWindowSize = () => {
            const width = window.innerWidth;
            shouldShowMobileDesign.value = width <= 991;
        };
        // Update shouldShowMobileDesign value when the window size changes
        window.addEventListener('resize', () => {
            updateWindowSize();
        });
        if (props.d.background_colour === undefined || props.d.background_colour === null)
            props.d.background_colour = '#fff';
        document.addEventListener('DOMContentLoaded', function () {
            const splide = new Splide(splider.value, {
                type: 'loop',
                pagination: false,
                perPage: 1,
                autoWidth: true,
                focus: 'center',
                gap: '5rem',
                drag: true,
                arrows: false,
                autoplay: true,
                pauseOnFocus: true,
                pauseOnHover: false,
            }).mount();
            // After mounting the Splide, set the initial slide to the center (latest article).
            splide.go('1'); // Move to the previous slide to position the latest article in the center.
            new HoverCursor({
                containerQuery: '.articles--slider',
                snapPosition: 'R',
                icon: '/images/explore.svg',
                toggledIcon: '/images/explore.svg',
                customClass: 'cursor'
            });
        });
        function splideClicked(alias) {
            window.location.href = alias;
        }
        function bigTextBreakerData() {
            return {
                title: props.d.title,
                background_colour: props.d.background_colour,
                desktop_container: true
            };
        }
        return (_ctx, _cache) => {
            const _component_big_text_breaker = _resolveComponent("big-text-breaker");
            const _component_article_carousel_item = _resolveComponent("article-carousel-item");
            const _component_article_item = _resolveComponent("article-item");
            const _component_smart_text = _resolveComponent("smart-text");
            return (_openBlock(), _createBlock(_component_smart_text, {
                class: "articles_listing_carousel",
                style: _normalizeStyle(`background-color: ${__props.d.background_colour ? __props.d.background_colour : '#fff'}`)
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_big_text_breaker, {
                            d: bigTextBreakerData()
                        }, null, 8, ["d"])
                    ]),
                    _createElementVNode("div", null, [
                        _createElementVNode("div", {
                            ref_key: "splider",
                            ref: splider,
                            class: "splide articles--slider inner"
                        }, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("ul", _hoisted_3, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.d.articles, (article) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            class: "splide__slide",
                                            onClick: ($event) => (splideClicked(article.alias))
                                        }, [
                                            (!shouldShowMobileDesign.value)
                                                ? (_openBlock(), _createBlock(_component_article_carousel_item, {
                                                    key: 0,
                                                    d: { align: 'right', article: article, shadow: true }
                                                }, null, 8, ["d"]))
                                                : _createCommentVNode("", true),
                                            (shouldShowMobileDesign.value)
                                                ? (_openBlock(), _createBlock(_component_article_item, {
                                                    key: 1,
                                                    d: { align: 'left', article: article }
                                                }, null, 8, ["d"]))
                                                : _createCommentVNode("", true)
                                        ], 8, _hoisted_4));
                                    }), 256))
                                ])
                            ])
                        ], 512)
                    ]),
                    (__props.d.show_footer === 'yes')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_8, [
                        (__props.d.show_back_to_insights)
                            ? (_openBlock(), _createElementBlock("a", _hoisted_9, "Back to Insights"))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _: 1
            }, 8, ["style"]));
        };
    }
});
